import { useCallback, useMemo } from "react";
import { useTranslation } from "i18n-fe";
import { formatSection, showSectionStyle } from "score-common";
import { useScoreContext } from "../context/ScoreContext";

// #3293 / #3295 - THE one place a section's display name is made. The data
// layer stores plain integers (#3292); the show carries a display setting
// (`Show.sectionLabel`: Section / Heat / Group / free text, and
// `Show.sectionNumbering`: numeric or alpha), formatted by score-common's
// formatSection. The scribe's selected show is the live record (ScoreContext
// re-reads it on connectivity / visibility, #2316), so a label changed in
// Score Admin shows up without re-picking the show. An unset label falls back
// to the translated default word "Section" with plain numbers.
export function useSectionLabel() {
  const { t } = useTranslation("score");
  const { selectedShow } = useScoreContext();
  const defaultLabel = t("classGrid.sections.defaultLabel");
  const sectionLabel = selectedShow?.sectionLabel;
  const sectionNumbering = selectedShow?.sectionNumbering;
  const style = useMemo(() => {
    const s = showSectionStyle({ sectionLabel, sectionNumbering });
    return { ...s, label: s.label ?? defaultLabel };
  }, [sectionLabel, sectionNumbering, defaultLabel]);
  return useCallback((n) => formatSection(n, style), [style]);
}
